import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

const CustomedTextField = styled(TextField)({
  // marginRight: 8,
  backgroundColor: "#FFFFFF"
});

export default function MonthRangePicker(props) {

  return(
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'ja'} dateFormats={{ monthAndYear: "YYYY年 MM月" }} >
      <DatePicker
        {...props}
        label="売上月"
        views={['year', 'month']}
        renderInput={(params) =>
          <CustomedTextField
            {...params}
          />
        }
      />
    </LocalizationProvider>
  )
}
